"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const labeled_value_1 = require("../labeled-value");
const bureau_logo_1 = require("../bureau-logo");
const score_display_1 = __importDefault(require("../score-display"));
const bureaus_1 = require("../../utils/bureaus");
const Tradelines = styled_components_1.default.section.withConfig({ displayName: "reports-Tradelines", componentId: "reports-t5g1mw" }) `
  display: block;
`;
const PublicFilings = styled_components_1.default.section.withConfig({ displayName: "reports-PublicFilings", componentId: "reports-yujrar" }) `
  display: block;
`;
const InfoCard = (0, styled_components_1.default)(base_react_components_1.StandardCard).withConfig({ displayName: "reports-InfoCard", componentId: "reports-j3hv7s" }) `
  background-color: ${base_react_components_1.theme.neutral100};
  border-radius: 4px;
  padding: 16px;
`;
const Card = (0, styled_components_1.default)(base_react_components_1.StandardCard).withConfig({ displayName: "reports-Card", componentId: "reports-pvxg3m" }) `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  & > ${score_display_1.default}, & > ${InfoCard}, & > ${base_react_components_1.Copy}, & > ${base_react_components_1.StandardCard.Header} {
    grid-column: span 2;
  }
`;
/**
 * The OverviewCard component provides a high level overview of a credit report
 */
const OverviewCard = ({ address = {
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
    extendedZip: '',
}, bureau, reportableType, businessName, publicFilingsCount = 0, hasUpgradeCTA = false, score, tradelineCount = 0, reportDate, }) => {
    var _a;
    const { street1, street2, city, state, zip, extendedZip } = address;
    const bureauSlug = (_a = (0, bureaus_1.getBureau)(bureau)) === null || _a === void 0 ? void 0 : _a.slug;
    return (react_1.default.createElement(Card, null,
        react_1.default.createElement(base_react_components_1.StandardCard.Header, null,
            react_1.default.createElement(bureau_logo_1.BureauLogo, { bureau: bureauSlug })),
        react_1.default.createElement(score_display_1.default, { bureau: bureauSlug, reportableType: reportableType, score: score, reportDate: reportDate }),
        react_1.default.createElement(Tradelines, null,
            react_1.default.createElement(labeled_value_1.LabeledValue, { label: react_1.default.createElement(react_1.default.Fragment, null,
                    "Tradelines",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(base_react_components_1.Link, { href: "/learn/tradelines" }, "Learn about tradelines")), underbar: "between" }, tradelineCount ? 'Yes' : 'No')),
        react_1.default.createElement(PublicFilings, null,
            react_1.default.createElement(labeled_value_1.LabeledValue, { label: react_1.default.createElement(react_1.default.Fragment, null,
                    "Public filings",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    react_1.default.createElement(base_react_components_1.Text, { "$bold": true }, "This may include:"),
                    " liens, collections, judgments, UCC bankruptcy"), underbar: "between" }, publicFilingsCount !== null && publicFilingsCount !== void 0 ? publicFilingsCount : 0)),
        react_1.default.createElement(InfoCard, null,
            react_1.default.createElement(base_react_components_1.Copy, { bold: true }, "Record shown for: "),
            react_1.default.createElement(base_react_components_1.Copy, null, businessName),
            react_1.default.createElement(base_react_components_1.Copy, null, street1),
            street2 && react_1.default.createElement(base_react_components_1.Copy, null, street2),
            react_1.default.createElement(base_react_components_1.Copy, null,
                city && `${city}, `,
                state,
                extendedZip ? `${zip}-${extendedZip}` : zip)),
        hasUpgradeCTA && react_1.default.createElement(base_react_components_1.Copy, null, "Nav can provide your entire report for a fraction of the price.")));
};
exports.OverviewCard = OverviewCard;
exports.default = (0, styled_components_1.default)(exports.OverviewCard).withConfig({ componentId: "reports-3obxhm" }) ``;
//# sourceMappingURL=index.js.map